import { render, staticRenderFns } from "./AnnotationDetails.vue?vue&type=template&id=fc91f85a&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"
import style0 from "./AnnotationDetails.vue?vue&type=style&index=0&id=fc91f85a&prod&scoped=true&lang=scss"
import style1 from "./AnnotationDetails.vue?vue&type=style&index=1&id=fc91f85a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc91f85a",
  null
  
)

export default component.exports